var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"leave-review-reviewers-select__select",attrs:{"name":"reviewers"},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}},_vm._l((_vm.reviewers),function(reviewer){return _c('option',{key:reviewer.user_id,domProps:{"value":reviewer.user_id}},[_vm._v("\n    "+_vm._s(reviewer.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }